import React from "react";
import { UserEngagement } from "../../../types/email-tracking.types";
import { formatOpenRateTable } from "./formatters";

interface TopUsersProps {
  data: UserEngagement[];
}

export const TopUsers: React.FC<TopUsersProps> = ({ data }) => {
  if (!data.length) {
    return (
      <div className="bg-white rounded-lg border border-neutral-200 p-4">
        <h4 className="text-sm font-semibold text-neutral-900 mb-1">
          Najaktywniejsi użytkownicy
        </h4>
        <p className="text-xs text-neutral-500 mb-3">Top 20 użytkowników</p>
        <div className="text-neutral-500 text-sm">
          Brak aktywności emailowej w wybranym okresie.
        </div>
      </div>
    );
  }

  return (
    <div
      className="bg-white rounded-lg border border-neutral-200 p-4"
      data-testid="ranking-top-users"
      role="region"
      aria-label="Najaktywniejsi użytkownicy"
    >
      <h4 className="text-sm font-semibold text-neutral-900 mb-1">
        Najaktywniejsi użytkownicy
      </h4>
      <p className="text-xs text-neutral-500 mb-3">Top 20 użytkowników</p>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs font-medium text-neutral-500 uppercase border-b border-neutral-200">
              <th
                scope="col"
                className="py-2 pr-3"
                title="Sortowane wg liczby otwarć (malejąco), następnie liczby wysłanych maili"
                aria-label="Pozycja. Sortowane wg liczby otwarć (malejąco), następnie liczby wysłanych maili"
              >
                #
              </th>
              <th scope="col" className="py-2 pr-3">Email</th>
              <th scope="col" className="py-2 pr-3">Tenant</th>
              <th scope="col" className="py-2 pr-3 text-right">Wysłane</th>
              <th scope="col" className="py-2 pr-3 text-right">Otwarcia</th>
              <th scope="col" className="py-2 pr-3 text-right">Open rate</th>
              <th scope="col" className="py-2 text-right">Kliknięcia</th>
            </tr>
          </thead>
          <tbody>
            {data.map((u, index) => (
              <tr
                key={u.userId}
                className="border-b border-neutral-50 last:border-0"
                data-testid={`top-user-row-${index}`}
              >
                <td className="py-2 pr-3 text-neutral-500">{index + 1}</td>
                <td className="py-2 pr-3 text-neutral-900 truncate max-w-[220px]" title={u.email}>
                  {u.email}
                </td>
                <td className="py-2 pr-3 text-neutral-600 truncate max-w-[180px]" title={u.tenantName ?? ""}>
                  {u.tenantName ?? "—"}
                </td>
                <td className="py-2 pr-3 text-right text-neutral-700">{u.sent}</td>
                <td className="py-2 pr-3 text-right font-medium text-neutral-900">{u.opened}</td>
                <td className="py-2 pr-3 text-right text-neutral-700">{formatOpenRateTable(u.openRate)}</td>
                <td className="py-2 text-right text-neutral-700">{u.clicks}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopUsers;
